/**
 * Wireframe — recommended image dimensions.
 *
 * In wireframe mode, shows an info-style hover tooltip on every image
 * placeholder with the recommended source dimensions at 72 DPI, derived from how
 * wide the placeholder actually renders in its container (recomputed live).
 *
 *   - Card / listing / media placeholders (real boxes) → measured W × H.
 *   - Full-width banner images (hero, page-header, cs-hero) → shown via a CSS
 *     ::after placeholder, so we inject a real element and recommend a
 *     full-width banner source instead of the small box.
 *
 * A single tooltip is appended to <body> (placeholders use overflow:hidden, so
 * an inline tooltip would be clipped) and positioned against each element.
 */
( function () {
	'use strict';

	var CARD_SELECTOR = [
		'.service-icon',
		'.service-featured-image',
		'.case-study-card-image',
		'.case-study-card-thumb',
		'.team-member-photo',
		'.team-member-image',
		'.blog-card-image',
		'.blog-card-thumb',
		'.gallery-item',
		'.logo-item'
	].join( ',' );

	var BANNER_HOST_SELECTOR = '.hero-section .wrap, .page-header .wrap, .cs-hero .wrap';

	function fmt( w, h ) {
		return Math.round( w ) + ' × ' + Math.round( h ) + ' px · 72 DPI';
	}

	function init() {
		if ( ! document.body.classList.contains( 'wireframe-mode' ) ) {
			return;
		}
		document.body.classList.add( 'wf-dims-on' );

		var tip = document.createElement( 'div' );
		tip.className = 'wf-dim-tip';
		document.body.appendChild( tip );

		var items = [];

		Array.prototype.forEach.call( document.querySelectorAll( CARD_SELECTOR ), function ( el ) {
			items.push( { el: el, banner: false } );
		} );

		// Inject a real placeholder per banner host (the visible one is ::after).
		Array.prototype.forEach.call( document.querySelectorAll( BANNER_HOST_SELECTOR ), function ( wrap ) {
			if ( wrap.querySelector( '.wf-img-ph' ) ) {
				return;
			}
			var ph = document.createElement( 'div' );
			ph.className = 'wf-img-ph wf-img-ph--banner';
			wrap.appendChild( ph );
			items.push( { el: ph, banner: true } );
		} );

		function textFor( item ) {
			if ( item.banner ) {
				var bw = Math.max( 1920, window.innerWidth || 0 );
				return 'Full-width banner — ' + fmt( bw, Math.round( bw * 9 / 16 ) );
			}
			return fmt( item.el.offsetWidth, item.el.offsetHeight );
		}

		function place( el ) {
			var r = el.getBoundingClientRect();
			var top = r.top - tip.offsetHeight - 8;
			if ( top < 4 ) {
				top = r.bottom + 8;
			}
			tip.style.top = Math.round( top ) + 'px';
			tip.style.left = Math.round( r.left + r.width / 2 ) + 'px';
		}

		items.forEach( function ( item ) {
			item.el.classList.add( 'wf-has-dim' );

			item.el.addEventListener( 'mouseenter', function () {
				tip.textContent = textFor( item );
				tip.classList.add( 'is-visible' );
				place( item.el );
			} );
			item.el.addEventListener( 'mouseleave', function () {
				tip.classList.remove( 'is-visible' );
			} );
		} );
	}

	if ( document.readyState !== 'loading' ) {
		init();
	} else {
		document.addEventListener( 'DOMContentLoaded', init );
	}
} )();
